 <template>
  <div class="cmp-b2b-home-lastest_statement dt-page">
    <div class="lastest_statement dt-page--data-table c2">
      <NTable
        :id="'b2b-home-lastest_statement'"
        :headers="headers"
        :items="items"
        class="lastest_statement h1"
        :config="royaltyTableConfig"
        thpad="0px"
        tdpad="0px"
        thspad="0px 10px 0px 10px"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item),
            }"
            @click="onRowClicked(item)"
          >
            <td v-bind="tdcon('detailsb2b_account')">
              <span :title="item['royalty_account_name']">{{
                item["royalty_account_name"]
              }}</span>
            </td>
            <td v-bind="tdcon('detailsb2b_period')">
              <span :title="item['identifier']">{{ item["period"] }}</span>
            </td>
            <td v-bind="tdcon('detailsb2b_total')">
              <span :title="item['period_payment']" style="text-align: right"
                >{{ item["period_payment"] }}&nbsp;
                <span style="font-weight: 500">{{
                  item["currency_iso"]
                }}</span></span
              >
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </div>
</template>

 


<script>
import NTable from "@/plugins/datatable/datatable";
import { B2BStoreNamespace as storeNS } from "../../store/index";
import { mapGetters, mapActions } from "vuex";
import * as types from "../../store/types";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

export default {
  components: {
    NTable,
  },
  props: {
    items: {
      type: Array,
    },
  },
  data() {
    return {
      royaltyTableConfig: createNTableConfig({
        scrollNextThreshold: 95,
      }),
    };
  },

  computed: {
    ...mapGetters(storeNS, {
      appNavItems: "appNavItems",
    }),
    headers: function () {
      return [
        createTableHeader("detailsb2b_account"),
        createTableHeader("detailsb2b_period", {
          minw: 40,
          mw: 150,
          ta: "center",
        }),
        createTableHeader("detailsb2b_total", {
          ta: "right",
          minw: 40,
          mw: 150,
        }),
      ];
    },
    royalties: function () {
      return [];
    },
  },

  methods: {
    ...mapActions(storeNS, {
      [types.B2B_FETCH_ROYALTIES_BY_YEAR]: types.B2B_FETCH_ROYALTIES_BY_YEAR,
    }),
    selectedRow(row) {},
    onRowClicked(row) {
      const year = row.period.split("-")[0];
      if (this.appNavItems && this.appNavItems.length > 0) {
        const mainItem = this.appNavItems.find((a) => a.route === "royalties");
        const subItem = mainItem.children.find((c) => c.route == year);
        this.$router.push({
          path: `/b2b/${subItem.parent}/${subItem.route}`,
        });
        this.$store.commit(
          `${storeNS}/${types.B2B_ACTIVE_SUB_ROUTE_ITEM}`,
          item
        );
        this[types.B2B_FETCH_ROYALTIES_BY_YEAR]();
      }
    },
  },
};
</script>

<style <style lang="scss"  >
.cmp-b2b-home-lastest_statement {
  height: 100%;
  overflow: hidden;
  margin: 0px 200px;
  // pointer-events: none;
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 0 40px;
  }
  .dt-ntable.lastest_statement {
    height: 100%;
    overflow: hidden;
    --ntable-height: 250px !important;
    td.stmt_link,
    td.excel_link,
    td.more_icon {
      cursor: pointer;
    }
    th:nth-child(7),
    td:nth-child(7) {
      display: none;
    }
    @media (min-width: 320px) and (max-width: 480px) {
      --ntable-height: 250px !important;

      th:nth-child(4),
      td:nth-child(4),
      th:nth-child(5),
      td:nth-child(5),
      th:nth-child(6),
      td:nth-child(6) {
        display: none;
      }
      th:nth-child(7),
      td:nth-child(7) {
        display: block;
      }
    }

    th {
      color: #282828;
      font-weight: 700;
      font-family: Roboto;
      font-size: 13px;
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border-bottom: 1px solid #c8c8c8;

      a {
        color: #0087ff;
        font-family: Roboto;
        font-size: 13px;
        line-height: 18px;
      }
    }
    td.btn_account {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    td {
      cursor: auto;
    }
    thead {
      tr {
        border-bottom: 1px solid #282828 !important;
      }
      th {
        color: #13110f !important;
      }
      &.style1 {
        --ntable-header-color: #13110f !important;
        --ntable-bb-color: #13110f !important;
      }
      &.style2 {
        --ntable-bb-color: #13110f !important;
      }
    }
  }
}
</style>

